import { render, staticRenderFns } from "./SocialAgent.vue?vue&type=template&id=47c46d79&"
import script from "./SocialAgent.vue?vue&type=script&lang=js&"
export * from "./SocialAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports